import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './pages/MainLayout';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import About from './pages/About';
import PhotosRoutes from './pages/PhotosRoutes';
import Photos from './pages/Photos';
import Matrimony from './pages/Matrimony';
import Register from './pages/Register';
import Login from './pages/Login';
import Form from './pages/Form';
import PhotoDetails from './pages/PhotoDetails';
import './App.css';
import Products from './pages/products';
import Cart from './pages/cart';
import LoginPrivate from './pages/PrivateLogin';
//import PhotoSelection from './pages/SelectedPhotos';
import GetSelectedPhotos from './pages/GetSelectedPhotos';
import SelectedPhotos from './pages/SelectedPhotos';



function App() {
  const [cart, setCart] = useState([]); 

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Main Layout Routes */}
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/pricing" element={<MainLayout><Pricing /></MainLayout>} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/about" element={<MainLayout><About /></MainLayout>} />
          <Route path="/matrimony" element={<MainLayout><Matrimony /></MainLayout>} />
          <Route path="/register" element={<MainLayout><Register /></MainLayout>} />
          <Route path="/login" element={<MainLayout><Login /></MainLayout>} />
          <Route path="/form" element={<MainLayout><Form /></MainLayout>} />
          <Route path="/photo-details" element={<PhotoDetails />} />
          <Route path="/loginprivate" element={<MainLayout><LoginPrivate /></MainLayout>} />
          <Route path="/selectedPhoto" element={<MainLayout><SelectedPhotos /></MainLayout>} />
          <Route path="/getSelected" element={<MainLayout><GetSelectedPhotos /></MainLayout>} />
          
          
          {/* Products and Cart Routes */}
          <Route
            path="/products"
            element={<MainLayout><Products cart={cart} setCart={setCart} /></MainLayout>}
          />
          <Route
            path="/cart"
            element={<MainLayout><Cart cart={cart} /></MainLayout>}
          />
          
          {/* Photo Category Routes - Open Separately */}
          <Route path="/*" element={<PhotosRoutes />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;